// extracted by mini-css-extract-plugin
export var wordContainer = "_q3-0";